module.exports = __webpack_public_path__ + "fa-light-300.svg?8ca375165a44ded899a24fa3264636fe";